import React from 'react';
import {makeStyles} from 'tss-react/mui';
import {FormattedMessage} from 'react-intl';
import ReplayIcon from '@mui/icons-material/Replay';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {agentDeveloperUtils} from 'wobi-web-common/dist/components/utils/helpers';
import whatsappIcon from '../../../assets/whatsapp-icon.svg';
import {useDocumentCollection} from '../context/DocumentCollectionContext';
import {SCREENS} from '../constants/documentCollection';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: '40px 20px',
    textAlign: 'center',
  },
  icon: {
    fontSize: theme.typography.pxToRem(64),
    color: theme.palette.primary.main,
    marginBottom: 20,
  },
  title: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 700,
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.text.primary,
    marginBottom: 12,
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.text.secondary,
    marginBottom: 32,
    lineHeight: 1.6,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'center',
  },
  retryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    border: 'none',
    borderRadius: 25,
    padding: '14px 32px',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    fontFamily: 'Ploni, Arial, sans-serif',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  whatsappButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    backgroundColor: '#25D366',
    color: '#fff',
    border: 'none',
    borderRadius: 25,
    padding: '14px 32px',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    fontFamily: 'Ploni, Arial, sans-serif',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#1da851',
    },
  },
  whatsappIcon: {
    width: 20,
    height: 20,
  },
}));

const ErrorScreen = () => {
  const {classes} = useStyles();
  const {setScreen} = useDocumentCollection();
  const agentData = agentDeveloperUtils.getAgentDeveloperData() || {};
  const whatsAppNumber = agentData?.websites?.auto?.whatsAppNumber || '972000000000';
  const whatsappLink = `https://wa.me/${whatsAppNumber}`;

  const handleRetry = () => {
    setScreen(SCREENS.LOADING);
    // Trigger re-fetch by resetting to loading — index.js will re-call page-model
    window.location.reload();
  };

  return (
    <div className={classes.container}>
      <ErrorOutlineIcon className={classes.icon} />
      <div className={classes.title}>
        <FormattedMessage id='docCollection.error.title' />
      </div>
      <div className={classes.subtitle}>
        <FormattedMessage id='docCollection.error.subtitle' />
      </div>
      <div className={classes.buttonsContainer}>
        <button
          type='button'
          className={classes.retryButton}
          onClick={handleRetry}
        >
          <ReplayIcon />
          <FormattedMessage id='docCollection.error.retry' />
        </button>
        <a
          href={whatsappLink}
          target='_blank'
          rel='noopener noreferrer'
          className={classes.whatsappButton}
        >
          <img src={whatsappIcon} alt='' className={classes.whatsappIcon} />
          <FormattedMessage id='docCollection.error.whatsapp' />
        </a>
      </div>
    </div>
  );
};

export default ErrorScreen;
